import PropTypes from 'prop-types';

const AdFormatIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_4148_12185)'>
        <path
          d='M19.0241 11.7479L19.6491 11.4745C19.9455 11.3448 20.0807 10.9993 19.951 10.7028C19.8213 10.4063 19.4758 10.2711 19.1794 10.4009L18.5544 10.6743C18.2579 10.804 18.1227 11.1495 18.2524 11.446C18.3822 11.7426 18.7279 11.8776 19.0241 11.7479Z'
          fill='#1E1E1E'
        />
        <path
          d='M19.6491 15.6352L19.0241 15.3618C18.7276 15.2321 18.3821 15.3672 18.2524 15.6637C18.1227 15.9602 18.2579 16.3057 18.5544 16.4354L19.1794 16.7088C19.4758 16.8385 19.8214 16.7033 19.951 16.4068C20.0807 16.1104 19.9455 15.7649 19.6491 15.6352Z'
          fill='#1E1E1E'
        />
        <path
          d='M19.4141 12.9688H18.7891C18.4655 12.9688 18.2031 13.2311 18.2031 13.5547C18.2031 13.8783 18.4655 14.1406 18.7891 14.1406H19.4141C19.7377 14.1406 20 13.8783 20 13.5547C20 13.2311 19.7377 12.9688 19.4141 12.9688Z'
          fill='#1E1E1E'
        />
        <path
          d='M11.3069 10.039C16.0255 7.69897 15.7098 7.85147 15.8202 7.8101V2.34374C15.8202 1.3746 15.0315 0.585938 14.0624 0.585938H1.7578C0.788666 0.585938 0 1.3746 0 2.34374V11.7577C0 12.7269 0.788666 13.5155 1.7578 13.5155H5.89839V12.578C5.89839 11.178 7.03745 10.039 8.43743 10.039H11.3069ZM5.82839 9.91852C5.43964 10.1129 4.98043 9.82954 4.98043 9.39442V4.70696C4.98043 4.27149 5.43968 3.98853 5.82839 4.18286L10.5159 6.52659C10.9472 6.74226 10.9468 7.35928 10.5159 7.57475L5.82839 9.91852Z'
          fill='#1E1E1E'
        />
        <path d='M6.15234 8.44664L8.94371 7.05098L6.15234 5.65527V8.44664Z' fill='#1E1E1E' />
        <path
          d='M8.43749 11.2105C7.68363 11.2105 7.07031 11.8238 7.07031 12.5777V14.5308C7.07031 15.1831 7.52968 15.7299 8.14187 15.8654L7.66421 18.7313C7.60468 19.0884 7.88046 19.4136 8.24218 19.4136H10.5859C10.8699 19.4136 11.1131 19.2099 11.1628 18.9302L11.6921 15.9529L11.7578 15.9855V11.123L11.5814 11.2105H8.43749Z'
          fill='#1E1E1E'
        />
        <path
          d='M16.185 8.92779L12.9297 10.542V16.5665L16.185 18.1807C16.573 18.3732 17.0312 18.0906 17.0312 17.6558V9.45274C17.0312 9.01822 16.5737 8.73502 16.185 8.92779Z'
          fill='#1E1E1E'
        />
      </g>
      <defs>
        <clipPath id='clip0_4148_12185'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

AdFormatIcon.propTypes = {
  className: PropTypes.string,
};

export default AdFormatIcon;
